import { render, staticRenderFns } from "./ContractorList.vue?vue&type=template&id=471ac6b6&"
import script from "./ContractorList.vue?vue&type=script&lang=ts&"
export * from "./ContractorList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports